import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import EntityReportFilter from "./EntityReportFilter";
import classes from "./index.module.css";

import AddEntity from "./addEntity";
import AddCustomerCategory from "./addCustomerCategory";
import EntityReportSummary from "./EntityReportSummary";

const Entity = () => {
  const [showAddEntity, setShowAddEntity] = useState(false);
  const [entityRowEditData, setEntityRowEditData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [showAddCustomerCategory, setShowAddCustomerCategory] = useState(false);

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const addEntity = useCallback((isEdit = false) => {
    if (isEdit) {
      setEntityRowEditData(() => reportRef.current.getCurrentRowData());
    }
    setShowAddEntity(true);
  }, []);

  const closeEntityAc = useCallback(() => {
    setShowAddEntity(false);
    setEntityRowEditData(null);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        refreshRef.current.click();
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "e") {
        return addEntity();
      }
      // if (altKey && key === "c") {
      //   setShowAddCustomerCategory(true);
      //   return;
      // }
    },
    [addEntity, currentRowData]
  );

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addEntity(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addEntity, currentRowData]);
  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddEntity &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddEntity]);

  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["customer-report-container"]}>
      <Reports
        identifier="entity"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        // filterParams={filterParams}
        // filterStates={filterStates}
        filters={
          <EntityReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            // refreshData={refreshData}
            // applyFilters={(params, filterStates) => {
            //   // refreshData(params);
            //   // setFilterParams(params);
            //   // setFilterStates(filterStates);
            // }}
            onFilterShow={onFilterShow}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <EntityReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addEntity();
        }}
        showCustomerCategoryAutoComplete={() => {
          setShowAddCustomerCategory(true);
        }}
      />
      <Autocomplete
        show={showAddEntity}
        height="80%"
        width="90%"
        closeAutoComplete={closeEntityAc}
      >
        <AddEntity
          entityRowEditData={entityRowEditData}
          onEscape={closeEntityAc}
          onSaveEntity={closeEntityAc}
        />
      </Autocomplete>
      <Autocomplete
        show={showAddCustomerCategory}
        height="40%"
        width="70%"
        closeAutoComplete={() => {
          setShowAddCustomerCategory(false);
        }}
      >
        <AddCustomerCategory
          onEscape={() => setShowAddCustomerCategory(false)}
        />
      </Autocomplete>
    </div>
  );
};

export default Entity;
